<template>
  <div class="sticky top-0 z-20 bg-white border-b shadow">
    <div
      class="flex flex-wrap justify-between items-center px-3 py-2 sm:pl-[88px] sm:pr-[38px] max-w-dstp xl2:mx-auto"
    >
      <router-link :to="{ name: 'dashboard' }" class="sm:py-[10px] profile">
        <img
          :src="LogoRect"
          alt="Logo"
          class="w-12 h-8 sm:w-[120px] sm:h-[44px] object-contain bg-transparent"
        />
        <span class="sr-only">{{ $t("dashboard") }}</span>
      </router-link>
      <div class="flex flex-wrap items-center justify-end flex-grow h-full">
        <div>
          <new-match-button @click="showModal" v-if="matchTypes.length > 0" />
          <router-link
            :to="{ name: 'dashboard' }"
            class="inline-flex items-center justify-start px-4 pb-1 text-lg font-bold text-gray-400 capitalize"
          >
            <span>{{ $t("dashboard") }}</span>
          </router-link>
          <router-link
            :to="{ name: 'analysis' }"
            class="inline-flex items-center justify-start px-4 pb-1 text-lg font-bold text-gray-400 capitalize"
          >
            <span>{{ $t("analysis") }}</span>
          </router-link>
        </div>
        <!-- <button class="relative sm:mr-8" type="button">
          <bell-icon class="w-7 h-7 text-neutral-400/90" />
          <span
            class="bg-yelloworange text-white h-[18px] w-[18px] -top-0.5 -right-0.5 rounded-l-xl rounded-r-xl flex items-center justify-center text-[10px] absolute"
            >1</span
          >
        </button> -->
        <router-link
          :to="{ name: 'profile' }"
          class="inline-flex items-center justify-center mr-6 profile"
        >
          <player-small-icon class="text-blue-500 w-9 h-9" />
          <span class="ml-2">{{ user.name }}</span>
          <chevron-down-icon class="w-5 h-5 ml-2 text-black" :strokeWidth="2" />
        </router-link>
        <div class="flex mr-4">
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="currentcolor"
            class="text-gray-400/90"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0ZM9.19925 2.90977L10.0398 3.49314C10.2257 3.62266 10.3763 3.79653 10.478 3.999L10.6894 4.42173C10.918 4.87997 11.3862 5.16945 11.8984 5.16925H13.4012C14.1479 5.16925 14.7532 5.77457 14.7532 6.52127V6.54805C14.7535 7.06022 14.464 7.52849 14.0057 7.75705L10.4005 9.56068C10.35 9.5853 10.3013 9.61331 10.2547 9.64452L8.40945 10.8747C8.21362 11.0055 8.05509 11.1849 7.94939 11.3953L7.67532 11.9463C7.4832 12.3261 7.4832 12.7747 7.67532 13.1546C7.93514 13.6755 7.83271 14.3043 7.42098 14.7158L7.38082 14.7567C6.94217 15.1954 6.26116 15.2791 5.72936 14.9596L3.37125 13.5435C3.09464 13.3772 2.88651 13.1176 2.78436 12.8115L2.20452 11.0712C2.19034 11.0712 2.17833 11.0689 2.16651 11.0665L2.16649 11.0665C2.156 11.0644 2.14566 11.0624 2.13407 11.0621C3.31662 7.51624 5.85753 4.58436 9.19925 2.90977ZM16.9197 20.8066C16.9506 20.7137 16.9663 20.6164 16.9662 20.5185L16.969 19.7583C16.9685 19.4129 16.7737 19.0971 16.4652 18.9417L14.5207 17.9701C14.2125 17.8148 14.0177 17.4994 14.0169 17.1543C14.0169 16.6498 13.609 16.2403 13.1045 16.2384H12.9157C12.6737 16.2379 12.4417 16.1416 12.2704 15.9706L12.0667 15.767C11.8956 15.5959 11.6634 15.4998 11.4214 15.5H10.149C9.80444 15.5017 9.49 15.6966 9.33523 16.0045L8.98295 16.7041C8.89497 16.8808 8.75175 17.024 8.57502 17.112L7.87541 17.4643C7.56691 17.6194 7.37187 17.9348 7.37095 18.2801V18.9142C7.37102 19.0943 7.42447 19.2704 7.52455 19.4201L8.71311 21.2033C8.80138 21.3357 8.92285 21.4426 9.06539 21.5133L9.82066 21.8902C10.1294 22.0455 10.3245 22.3612 10.3251 22.7068V25.6138C10.3253 25.7553 10.3581 25.8949 10.4209 26.0217L10.9965 27.1729C11.0407 27.2606 11.0985 27.3407 11.1677 27.4103L12.0738 28.3164C12.352 28.5932 12.7756 28.6621 13.1271 28.4876L13.616 28.2424C13.8674 28.1173 14.047 27.8834 14.1029 27.6083L14.6996 24.6267C14.7347 24.4499 14.8215 24.2876 14.949 24.1603L16.0763 23.033C16.1764 22.9329 16.2516 22.8108 16.2961 22.6765L16.9197 20.8066ZM20.6791 7.12577C20.742 6.97357 20.8341 6.83521 20.9504 6.71855L22.2122 5.45741C22.3073 5.36241 22.4169 5.2832 22.537 5.2228L23.8615 4.56052C23.9773 4.50533 24.1009 4.46848 24.2279 4.45132C25.7494 5.65083 27.0079 7.15039 27.9254 8.85684H27.3025C26.9705 8.85686 26.6519 8.7251 26.4169 8.49048L26.2648 8.33829C26.0298 8.10348 25.7113 7.97147 25.3791 7.97123H24.4224C24.2267 7.97068 24.0337 8.01605 23.8587 8.10368L22.6173 8.72509C22.4423 8.81243 22.2493 8.85755 22.0537 8.85684H21.8303C21.4123 8.85655 21.022 8.64775 20.7897 8.3002C20.5574 7.95264 20.5138 7.51212 20.6735 7.12577H20.6791ZM25.8991 24.6591L25.9907 24.8838C29.174 21.363 30.3473 16.4646 29.1048 11.8836H26.8016C26.6426 11.8834 26.4847 11.8577 26.3338 11.8075L24.7556 11.2812C24.489 11.1924 24.2026 11.1814 23.9299 11.2495L21.6429 11.8216C21.4788 11.8624 21.3229 11.9313 21.1822 12.0252L19.8379 12.9214C19.4272 13.195 19.1805 13.6559 19.1805 14.1494V15.3337C19.1807 15.4925 19.2064 15.6502 19.2566 15.8008L19.5821 16.778C19.7836 17.3806 20.3474 17.7873 20.9828 17.7884H21.0469C21.2758 17.7882 21.5015 17.7349 21.7063 17.6327L22.2115 17.3797C22.669 17.1512 23.2122 17.1759 23.6472 17.4448C24.0821 17.7137 24.3469 18.1887 24.347 18.7V18.9156C24.3471 19.1448 24.4004 19.3708 24.5027 19.5758L25.668 21.905C25.7703 22.1101 25.8236 22.336 25.8237 22.5652V24.192C25.8237 24.3507 25.8491 24.5084 25.8991 24.6591Z"
            />
          </svg>
          <select
            name="name"
            id=""
            class="py-0 pl-2 pr-8 text-black uppercase border-0 outline-none focus:ring-0"
            @change="changeI18nLocale($event.target.value)"
          >
            <option
              v-for="(lang, i) in langs"
              :key="`Lang${i}`"
              :value="lang"
              :selected="lang == $i18n.locale"
            >
              {{ lang }}
            </option>
          </select>
        </div>
        <button
          class="p-2 text-white rounded-full bg-cadmium"
          v-on:click="logout()"
        >
          <svg class="w-[18px] h-[18px]" viewBox="0 0 17 20" fill="none">
            <path
              d="M12.1113 18.1562C12.1113 18.6222 11.7497 19 11.3038 19H3.69158C2.20575 18.9983 1.00167 17.7401 1 16.1875V3.8125C1.00167 2.25992 2.20575 1.00174 3.69158 1H11.3038C11.7497 1 12.1113 1.37776 12.1113 1.84375C12.1113 2.30974 11.7497 2.6875 11.3038 2.6875H3.69158C3.09724 2.68818 2.61559 3.19146 2.61495 3.8125V16.1875C2.61558 16.8085 3.09723 17.3118 3.69158 17.3125H11.3038C11.7497 17.3125 12.1113 17.6903 12.1113 18.1562ZM15.7635 9.4034L11.9263 5.39376C11.7231 5.17664 11.4239 5.09038 11.1429 5.1679C10.8619 5.24543 10.6424 5.47477 10.5683 5.76841C10.4941 6.06205 10.5767 6.37468 10.7845 6.587L13.2431 9.15625H6.88644C6.44049 9.15625 6.07897 9.53401 6.07897 10C6.07897 10.466 6.44049 10.8438 6.88644 10.8438H13.2431L10.7844 13.413C10.5794 13.6259 10.4991 13.9371 10.5736 14.2289C10.6482 14.5206 10.8663 14.7485 11.1455 14.8264C11.4247 14.9043 11.7225 14.8203 11.9263 14.6062L15.7635 10.5966C16.0788 10.2671 16.0788 9.7329 15.7635 9.4034Z"
              fill="white"
              stroke="white"
              stroke-width="0.3"
            />
          </svg>
          <span class="sr-only">{{ $t("logout") }}</span>
        </button>
      </div>
    </div>
  </div>
  <!--Modal-->
  <NewMatch ref="newmatchform" />
  <licence-purchase-model ref="licencepurchasemodel" />
  <!--Modal-->
</template>

<script>
import NewMatch from "@/components/NewMatch.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
// import BellIcon from "@/components/icons/BellIcon.vue";
import LogoRect from "@/assets/images/default/logo_rect.svg";
import { mapState, mapGetters } from "vuex";
import Trans from "@/i18n/translation";
import userDataService from "@/services/userDataServices";
import PlayerSmallIcon from "@/components/icons/PlayerSmallIcon.vue";
import LicencePurchaseModel from "@/components/LicencePurchaseModel.vue";
import NewMatchButton from "./NewMatchButton.vue";

export default {
  components: {
    PlayerSmallIcon,
    NewMatch,
    ChevronDownIcon,
    // BellIcon,
    NewMatchButton,
    LicencePurchaseModel,
  },
  computed: {
    ...mapState(["user", "matchTypes"]),
    ...mapGetters(["newMatchPermission"]),
  },
  data() {
    return {
      LogoRect,
      langs: ["cz", "en"],
    };
  },
  methods: {
    showModal() {
      if (this.newMatchPermission) {
        this.$refs.newmatchform.openModal();
      } else {
        this.$refs.licencepurchasemodel.openModal();
      }
    },
    changeI18nLocale(value) {
      Trans.switchLanguage(value);
    },
    async logout() {
      await userDataService
        .userLogout()
        .then((response) => {
          if (response.status === 200 || response.status === 204) {
            this.$store.dispatch("logout");
            localStorage.removeItem("token");
            this.$router.push({ name: "login" });
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 400) {
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style scoped>
.router-link-active:not(.profile) {
  @apply border-b-[3px] border-yelloworange text-black;
}
</style>
